module.exports = __webpack_public_path__ + "static/media/tyre-red-two1.139d1fba.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/tyre-red-two1.png
// module id = 337
// module chunks = 0